import { simple_plural } from 'webui/utils/plural';
import { PanelsKeys } from 'console/shared/content/panels/types';
export function getHeatingCircuitsPanelTitle(length = 0) {
    return `${simple_plural(length, 'Отопительный', 'Отопительные')} ${simple_plural(length, 'Контур', 'Контуры')}`;
}
export function getBoilerHeatingCircuitsPanelTitle(length = 0) {
    return `${simple_plural(length, 'Котловой', 'Котловыe')} ${simple_plural(length, 'контур', 'контуры')}`;
}
export function getBoilerHeatingModesPanelTitle(length = 0) {
    return `${simple_plural(length, 'Котловой', 'Котловые')} ${simple_plural(length, 'Режим', 'Режимы')}`;
}
export function getHeatingModesPanelTitle(length = 0) {
    return `${simple_plural(length, 'Отопительный', 'Отопительные')} ${simple_plural(length, 'Режим', 'Режимы')}`;
}
export function getSensorsPanelTitle(length = 0) {
    return simple_plural(length, 'Датчик', 'Датчики');
}
export function getRfIndicatorsPanelTitle(length = 0) {
    return simple_plural(length, 'Радиоустройство', 'Радиоустройства');
}
export function getPanelName(panel_key, length) {
    switch (panel_key) {
        case PanelsKeys.heating_circuits:
            return getHeatingCircuitsPanelTitle(length);
        case PanelsKeys.boiler_heating_circuits:
            return getBoilerHeatingCircuitsPanelTitle(length);
        case PanelsKeys.boiler_heating_modes:
            return getBoilerHeatingModesPanelTitle(length);
        case PanelsKeys.heating_modes:
            return getHeatingModesPanelTitle(length);
        case PanelsKeys.guard_zones:
            return 'Охрана';
        case PanelsKeys.thermometers:
            return 'Температура';
        case PanelsKeys.sensors:
            return getSensorsPanelTitle(length);
        case PanelsKeys.custom_controls:
            return 'Управление и статус';
        case PanelsKeys.guard_control:
            return 'Управление охраной';
        case PanelsKeys.rf_indicators:
            return getRfIndicatorsPanelTitle(length);
        default:
            return undefined;
    }
}
